import MasonryGalleryContainer from "../../Componant/Gallery/MasonryGallery";

const MasonryGallery = () => {
  return (
    <div className="page-body">
      <MasonryGalleryContainer />
    </div>
  );
};

export default MasonryGallery;
